import { mapActions } from 'vuex'
import { judgeClientSystem } from '@/assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
export default {
  data () {
    return {
      source: ''
    }
  },
  async mounted () {
    window.addEventListener('pageshow', () => {
      if (sessionStorage.getItem('isPageHideMiddle') || localStorage.getItem('isPageHideMiddle')) {
        localStorage.removeItem('isPageHideMiddle')
        this.$nextTick(() => {
          if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
            return jsBridge('exit')
          } else {
            return this.$router.push('/')
          }
        })
      }
      if (hasNativeMethod('navigateTo') && judgeClientSystem() === 'Android') {
        if (sessionStorage.getItem('isPageHideMiddle')) {
          sessionStorage.removeItem('isPageHideMiddle')
        } else {
          sessionStorage.setItem('isPageHideMiddle', 'T')
        }
      }
    })
    const { url, benefitType } = this.$route.query
    const { success, data } = await this.queryVipMemberNo()
    if (success && data) {
      // 调用接口 
      const res = await this.getToken({
        benefitType,
        memberNo: data.memberNo
      })
      if (res.success && res.data) {
        if (hasNativeMethod('navigateTo') && judgeClientSystem() === 'Android') {
          window.location.href = `${url}&user_token=${res.data.jwtToken}&return_url=https://oakvip-h5.xiangshuheika.com/`
        } else {
          if (localStorage.getItem('isPageHideMiddle')) {
            localStorage.removeItem('isPageHideMiddle')
            this.$router.push('/')
          } else {
            localStorage.setItem('isPageHideMiddle', 'T')
            window.location.href = `${url}&user_token=${res.data.jwtToken}&return_url=https://oakvip-h5.xiangshuheika.com/`
          }
        }
      } else {
        if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
          return jsBridge('exit')
        } else {
          return this.$router.push('/')
        }
      } 
    }
  },
  methods: {
    ...mapActions('vip', ['getToken', 'queryVipMemberNo'])
  },
  render () {
    return <div/>
  }
}